export default {
  message: {
    Tour: {
      continue: "Continua",
      back: "Indietro",
      finish: "Fine"
    },
    Login: {
      title: "Accesso genitori",
      sign_in: "Accedi",
      login_fail:
        "Autenticazione non riuscita. Riprova o contatta la scuola per assistenza con l'accesso.",
      forgot_password: "Password dimenticata",
      create_account: "Crea account",
      password: "Password",
      confirm_password: "Conferma password",
      password_reminder: "Promemoria password",
      enter_email: "Inserisci il tuo indirizzo email",
      validation_error: "Errore di validazione",
      password_reminder_error_no_user_register:
        "Il nome utente inserito non è stato trovato. Riprova o crea un nuovo account.",
      password_reminder_error_no_user: "Il nome utente inserito non è stato trovato.",
      password_reminder_sent: "È stata inviata un'email con ulteriori istruzioni a {email}.",
      password_reminder_sent_message:
        "L'email potrebbe impiegare alcuni minuti per arrivare. Controlla anche la cartella spam.",
      password_trouble_email: "Se hai ancora problemi, contatta {email}.",
      password_trouble_school:
        "Se hai ancora problemi, contatta la scuola per assistenza.",
      return_to_sign_in: "Torna all'accesso",
      create_my_account: "Crea il mio account",
      or_sign_in_with: "OPPURE ACCEDI CON",
      password_reset: "Scegli una nuova password per il tuo account.",
      password_reset_warning:
        "Se non hai richiesto di cambiare la password, contatta immediatamente l'amministratore della scuola.",
      password_update: "Scegli nuova password",
      password_update_confirm: "Conferma nuova password",
      password_update_success: "La tua nuova password è stata salvata."
    },
    AccountSettings: {
      title: "Impostazioni account",
      first_name: "Nome",
      last_name: "Cognome",
      email: "Email",
      username: "Nome utente",
      password: "Password",
      students: "Studenti",
      teachers: "Insegnanti",
      external_id: "ID esterno",
      phone: "Numero di telefono",
      phone_required: "Il numero di telefono è obbligatorio",
      edit: "Modifica",
      remove: "Rimuovi",
      add: "Aggiungi",
      remove_message: "Sei sicuro di voler rimuovere questo studente?",
      yes: "Sì",
      no: "No",
      add_student: "Aggiungi studente",
      close: "Chiudi",
      save: "Salva modifiche",
      cancel: "Annulla",
      student_alert_message: "Devi inserire almeno uno studente.",
      logout: "Esci"
    },
    TrialStatus: {
      title: "Update Trial Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      updatedSuccess: "Trial status updated successfully",
      updateError: "Failed to update trial status",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    LeadStatus: {
      title: "Update Lead Status",
      schoolLabel: "School",
      currentStatus: "Current Status",
      newStatus: "New Status",
      reject: "Reject",
      updatedSuccess: "Lead status updated successfully",
      updateError: "Failed to update lead status",
      convertedNote: "This marks the lead as a customer. If a school exists, it may be set to active.",
      suppressedNote: "This suppresses the lead. You can restore it later from Suppressed.",
      statuses: {
        requested: "Requested",
        pending: "Pending",
        fullfilled: "Fulfilled",
        expired: "Expired",
        cancelled: "Cancelled",
        rejected: "Rejected",
        converted: "Converted"
      }
    },
    WelcomeEmail: {
      title: "Send welcome email?",
      schoolLabel: "School",
      districtLabel: "District",
      contactLabel: "Contact",
      emailLabel: "Email",
      subdomainLabel: "Subdomain",
      usernameLabel: "Username",
      body: "PTC Wizard will email this account's admin-site credentials and documentation links.",
      confirm: "Send email",
      cancel: "Cancel",
      success: "Welcome email sent",
      error: "Failed to send welcome email",
      tooltip: "Send welcome email"
    },
    Navbar: {
      my_meetings: "I miei appuntamenti",
      language: "Italiano",
      help: "Aiuto",
      account_settings: "Impostazioni account",
      user_management: "User Management",
      logout: "Esci"
    },
    SubNavbar: {
      meeting: "Appuntamento",
      event: "Evento",
      print: "Stampa",
      email: "Email",
      export: "Esporta"
    },
    ConferenceCard: {
      add_edit_meetings: "Aggiungi/Modifica appuntamenti",
      opening: "Apertura",
      closed: "Chiuso"
    },
    Agenda: {
      full_agenda: "Agenda completa",
      empty_state_title: "Non abbiamo trovato conferenze per te.",
      empty_state_message: "Per qualsiasi domanda, contatta il rappresentante della scuola.",
      confirmation_modal_title: "Agenda confermata",
      confirmation_modal_message:
        "La tua agenda è stata confermata con successo e ti è stata inviata un'email.",
      complete_button: "Fatto!"
    },
    AgendaCard: {
      room: "Aula non disponibile",
      room_with_value: "Aula: {room}",
      virtual_meeting: "Riunione virtuale",
      all_conferences: "Tutte le conferenze",
      conference: "Conferenza",
      student: "Studente",
      meeting_with: "Incontro con",
      date_time: "Data/Ora",
      meeting_type: "Tipo di incontro",
      location: "Posizione",
      comment: "Commento",
      action: "Azione",
      delete: "Elimina",
      add_comment: "Aggiungi commento",
      join: "Partecipa alla riunione",
      choose_meeting_type: "Scegli il tipo di incontro",
      in_person: "Di persona",
      phone: "Telefono",
      callback: "Richiamata",
      virtual: "Virtuale",
      hybrid: "Ibrido",
      unavailable: "Non disponibile",
      tooltip_translator:
        "Il servizio di traduzione non è garantito, ma la scuola farà ogni sforzo per renderlo disponibile.",
      translator_requested: "Traduttore richiesto",
      clear_translator: "Cancella richiesta traduttore",
      need_translator: "Hai bisogno di un traduttore?",
      choose_language: "Scegli una lingua"
    },
    ScheduleMatrix: {
      no_teachers_title: "Nessun insegnante o team selezionato.",
      no_teachers_message: "Scegli un insegnante per visualizzare gli orari degli incontri.",
      choose_teachers_button: "Visualizza insegnanti o team disponibili",
      choose_student: "Per quale studente?",
      cancel: "Annulla"
    },
    Matrix: {
      teachers: "Insegnanti",
      agenda: "Rivedi e continua"
    },
    DrawerTeachers: {
      teachers: "Insegnanti",
      name: "Nome",
      description: "Descrizione",
      student: "Studente",
      teacher_team: "Insegnante/Team",
      show_more: "Mostra più insegnanti",
      show_all: "Mostra tutti gli insegnanti della scuola",
      selected: "({count}) selezionato/i",
      closeDrawer: "Continua alla pianificazione",
      search: "Cerca un insegnante o team",
      not_available: "Questo insegnante non ha orari di incontro disponibili il {date}."
    },
    DrawerAgenda: {
      no_meetings_title: "Non hai incontri programmati.",
      no_meetings_message: "Dopo aver scelto un insegnante e una fascia oraria, apparirà qui.",
      new_meeting_label: "Nuovo",
      cancel_button: "Annulla",
      student_label: "Studente",
      meeting_type_location: "Tipo/Posizione incontro",
      comment_label: "Commento",
      save_comment_button: "Salva commento",
      confirm_label: "Conferma per favore:",
      confirm_cancel_button: "Sì, annulla il mio incontro con ",
      do_not_cancel_button: "Non annullare",
      confirm_agenda_button: "Conferma questa agenda",
      confirm_agenda_message_line1: "Puoi sempre tornare e apportare modifiche.",
      confirm_agenda_message_line2: "La tua agenda attuale ti verrà inviata via email."
    },
    EmailConsent: {
      message:
        "Per proteggere la tua privacy e sicurezza, abbiamo bisogno del tuo consenso per inviare comunicazioni al tuo indirizzo email.",
      consent: "Acconsento"
    },
    UserManagement: {
      pageTitle: "User Management",
      pageSubtitle:
        "Add and manage school and district staff accounts. Staff sign in with school or district login using this site's account.",
      addUser: "Add user",
      editUser: "Edit user",
      loading: "Loading users…",
      emptyTitle: "No staff users yet",
      emptyMessage: "Use Add user to create a school or district staff account.",
      tableUsername: "Username",
      tableEmail: "Email",
      tableRole: "Role",
      tableActions: "Actions",
      typeSchool: "School",
      typeDistrict: "District",
      roleTeam: "Team",
      roleSchool: "School Admin",
      roleReporter: "School Reporter",
      roleDistrict: "District Admin",
      roleNoIntegration: "School Admin without Integration",
      roleNotSet: "Role not set",
      roleUnknown: "Role ({id})",
      formUsername: "Username",
      formEmail: "Email",
      formPassword: "Password",
      formNewPassword: "New password (optional)",
      formRole: "Role",
      loginHint:
        "Staff sign in with the school portal. District staff may use the district portal subdomain when applicable.",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      confirmDeleteTitle: "Remove this user?",
      confirmDeleteBody:
        "This will remove the staff account from your school. This action cannot be undone.",
      validationRequired: "Please fill in all required fields.",
      createdSuccess: "User created.",
      updatedSuccess: "User updated.",
      deletedSuccess: "User removed.",
      genericError: "Something went wrong. Please try again.",
      changeRoleTitle: "Change role",
      roleUpdatedSuccess: "Role updated.",
      deleteUserAria: "Remove user",
      formSchool: "School",
      validationSchoolRequired: "Please select a school.",
      schoolListEmpty: "No schools are available in this district."
    },
    StudentsDirectory: {
      saveLinkHousehold: "Save link household",
      saveLinkHouseholdNothing: "No changes to save.",
      saveLinkHouseholdSuccess: "Link household updated for {count} students.",
      saveLinkHouseholdError: "Could not update link household.",
      saveLinkHouseholdPartial: "Updated {saved} students; {failed} could not be saved."
    }
  }
};
